export default [
  
    {
        path: '/manage/demo-requests',
        name: 'demo-requests',
        component: () => import('@/views/sales/CustomerDemo.vue'),
        meta: {
            pageTitle: 'Demo Talepleri',
            pageIcon: 'FigmaIcon',
            requiresAuth : true
        },
    },
]